import { Flex, Typography } from 'antd';
import { useTracking } from 'common/utils';
import { captureError } from 'common/utils/monitoring.util';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ErrorContainer } from './something-went-wrong.style';

export const SomethingWentWrong = ({
  error,
  componentStack,
}: {
  error: Error;
  componentStack: string;
}) => {
  const [t] = useTranslation();

  const { track } = useTracking();
  const pathLocation = globalThis?.location?.pathname;
  const screen = pathLocation?.split('/')?.[5] ?? pathLocation;

  useEffect(() => {
    track(`Whoops Screen - Something went wrong`, {
      screen,
    });

    captureError(error, {
      componentStack,
      message: error?.message,
      isCrash: true,
      source: 'custom',
      domain: 'ErrorBoundary',
    });
  }, [screen, track, error, componentStack]);

  const handleReloadPage = useCallback(() => {
    track(`Whoops Screen - Clicked button try again`, {
      screen,
    });
    globalThis.location.reload();
  }, [screen, track]);

  return (
    <ErrorContainer data-testid="something-went-wrong-container">
      <img src="/assets/something-went-wrong.png" alt="Error illustration" />
      <Flex align="center" justify="center" vertical>
        <Typography.Title level={2} style={{ marginBottom: 0 }}>
          {t('whoops.page_could_not_be_loaded.title')}
        </Typography.Title>
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          {t('whoops.page_could_not_be_loaded.subtitle')}
        </Typography.Title>
        <Typography.Paragraph>
          {t('whoops.page_could_not_be_loaded.description')}
        </Typography.Paragraph>
      </Flex>

      <Button size="large" type="primary" onClick={handleReloadPage}>
        {t('button.try_again')}
      </Button>
    </ErrorContainer>
  );
};
